import { gql } from '@apollo/client';

export const CHECK_DUPLICATE_PASSPORT_NUMBER_OR_ID_NUMBER = gql`
  query CheckDuplicatePassportNumberOrIdNumber($input: DuplicatesInput) {
    person: checkDuplicatePassportNumberOrIdNumber(input: $input) {
      id
      firstName
      associatedInstitutions {
        id
        institution {
          id
          name
        }
      }
      associatedOrganisations {
        id
        organisation {
          id
          institution {
            id
            name
          }
          funder {
            id
            name
          }
          serviceProvider {
            id
            name
          }
        }
      }
      institutions {
        id
        name
      }
    }
  }
`;
